// Dumb dialog — no store, no SQL, no ApiClient, no analytics. It collects the
// report options and hands them to the parent.
//
//   props:  modelValue (Boolean)  v-model for the open state
//           generating (Boolean)  drives the spinner and disables the form
//           opt-in (IA_ABSORPTION_PLAN 13.4; the defaults are project-overview's dialog):
//           disabledModes (Array)   modes whose toggle button renders disabled ('grid' | 'matrix')
//           groupByOptions (Array)  [{ title, value }] — the Grid mode's "Group by" select,
//                                   initially the first option; empty = no select
//           orderByOptions (Array)  [{ title, value }] — the Grid mode's "Order by" select, likewise
//   emits:  update:modelValue     open/close
//           generate(options)     { mode, reportType, fileFormat, pageSize }, plus `groupBy` /
//                                 `orderBy` (the selected values) when their options are given;
//                                 the parent runs the report (project-overview: ItemsGrid adds
//                                 itemsView + the debounced search and runs useItemsGridReport)
import setup from './setup.js';

const MODES = ['grid', 'matrix'];
const isOptionList = (list) => Array.isArray(list) && list.every((o) => o && typeof o.title === 'string' && 'value' in o);

export default {
  name: 'items-grid-paginated-reports-dialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    generating: {
      type: Boolean,
      default: false
    },
    disabledModes: {
      type: Array,
      default: () => [],
      validator: (modes) => modes.every((m) => MODES.includes(m))
    },
    groupByOptions: {
      type: Array,
      default: () => [],
      validator: isOptionList
    },
    orderByOptions: {
      type: Array,
      default: () => [],
      validator: isOptionList
    }
  },
  emits: ['update:modelValue', 'generate'],
  setup,
};
